import { render, staticRenderFns } from "./xxzyzyjnyc.vue?vue&type=template&id=10c70e6f&scoped=true&"
import script from "./xxzyzyjnyc.vue?vue&type=script&lang=js&"
export * from "./xxzyzyjnyc.vue?vue&type=script&lang=js&"
import style0 from "./xxzyzyjnyc.vue?vue&type=style&index=0&id=10c70e6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c70e6f",
  null
  
)

export default component.exports